import { Avatar, Box, List, ListItem, Typography } from "@mui/material";

interface IProps {
  characteristics: {
    iconUrl: string;
    description: string;
  }[];
}

const Characteristics: React.FC<IProps> = ({ characteristics }) => {
  return (
    <List
      sx={{
        pt: { xs: 4, md: 6, lg: 8 },
        display: "flex",
        flexDirection: "column",
        gap: { xs: 3, lg: 4 },
      }}
      disablePadding
    >
      {characteristics.map((char, index) => (
        <ListItem key={index} disablePadding>
          <Box display="flex">
            <Avatar
              src={char.iconUrl}
              sx={{
                width: 24,
                height: 24,
                mr: 1.5,
              }}
            />
            <Typography variant="subtitle1" component="p" fontWeight={700}>
              {char.description}
            </Typography>
          </Box>
        </ListItem>
      ))}
    </List>
  );
};

export default Characteristics;
